import { BROADCAST_SET_DESIRED_KNOCK_AV_STATUS } from 'actions/Types';

/**
 * @param {string} socketId knock id
 * @param {boolean} isCameraOn default true/ON
 * @param {boolean} isMicrophoneOn default false/OFF
 * @description Explicitly sets presenter knock AV status before they join
 * unlike BROADCAST_SET_DESIRED_ATTENDEE_MUTE_STATUS and BROADCAST_SET_DESIRED_ATTENDEE_CAMERA_STATUS
 * which toggles AV status after presenter has already joined.
 */
export default (id, isCameraOn, isMicrophoneOn) => {
  return dispatch => {
    const action = {
      type: BROADCAST_SET_DESIRED_KNOCK_AV_STATUS,
      payload: { id, isCameraOn, isMicrophoneOn }
    };

    dispatch(action);
  };
};
